import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from 'actions'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { get as getConfig } from 'config'
import FormsyForm from 'formsy-react'
import { EmailInput } from 'components/FormInput.v2'
import { EMAIL_CAPTURED_GA4_EVENT } from 'services/event-tracking'
import { ERROR_EMAIL_INVALID, ERROR_EMAIL_REGISTRATION_ERROR } from 'services/email-signup'
import { H2, H6, HEADING_TYPES } from 'components/Heading'
import Sherpa from 'components/Sherpa'
import Button, { TYPES } from 'components/Button'
import IconV2, { ICON_TYPES } from 'components/Icon.v2'

function getClassName (className) {
  return ['email-capture'].concat(className || []).join(' ')
}

const { appLang } = getConfig()

class EmailCapture extends Component {
  //
  constructor (props) {
    super(props)
    this.state = {
      canSubmit: false,
    }
  }

  componentDidUpdate (prevProps) {
    const { emailSignup: nextEmailSignup, setEventLead } = this.props
    const { emailSignup: prevEmailSignup } = prevProps

    if (nextEmailSignup.get('success') && nextEmailSignup.get('success') !== prevEmailSignup.get('success')) {
      setEventLead(nextEmailSignup.get('email', ''))
    }
  }

  onEmailSignup = (formData) => {
    const { props } = this
    const {
      onFormSubmit,
      formName,
      siteSegment,
      user,
      signupEvent,
      url,
      utm,
      name,
      uiLocation,
      setDefaultGa4Event,
    } = props

    const emailSignup = formData[name]

    const userLanguage = user.getIn(['data', 'language', 0], appLang)

    onFormSubmit(emailSignup, formName, siteSegment, userLanguage, url, utm)

    if (signupEvent) {
      signupEvent()
    }

    // GA4 event
    const emailCapturedEventData = EMAIL_CAPTURED_GA4_EVENT
      .mergeDeep({
        ui_location: uiLocation,
      })

    setDefaultGa4Event(emailCapturedEventData)
  }

  onSelectOptInCheckbox = (name, checked) => {
    const { setEmailSignupOptin } = this.props

    setEmailSignupOptin(checked)
  }

  onReset = () => {
    this.setState(() => ({ canSubmit: false }))
  }

  enableButton = () => {
    this.setState(() => ({ canSubmit: true }))
  }

  disableButton = () => {
    this.setState(() => ({ canSubmit: false }))
  }

  render () {
    const { props, state } = this
    const {
      backgroundGradient,
      inputPlaceholder,
      successText,
      emailSignup,
      staticText,
      buttonText,
      className,
      withTitle,
      inverted,
      subtext,
      success,
      name,
      uid,
      processing,
    } = props

    // only show email capture for anonymous
    if (uid) {
      return null
    }

    const text = buttonText || staticText.getIn(['data', 'signUp'], 'Sign Up')
    const placeholder = inputPlaceholder || staticText.getIn(['data', 'formPlaceHolder'])
    const errorCode = emailSignup.get('errorCode')
    let errorMessage = ''
    const submitDisabled = state.canSubmit ? false : true // eslint-disable-line

    const gradient = backgroundGradient ? 'email-capture__gradient' : ''

    if (errorCode === ERROR_EMAIL_INVALID) {
      errorMessage = staticText.getIn(['data', 'errorMessageInvalidEmail'])
    } else if (errorCode === ERROR_EMAIL_REGISTRATION_ERROR) {
      errorMessage = staticText.getIn(['data', 'errorMessageRegistrationError'])
    }

    if (!getConfig().features.emailCapture) {
      return null
    }

    if (success) {
      return (
        <div className={getClassName(className)}>
          <H2 as={HEADING_TYPES.H6} className="email-capture__title--success">
            <IconV2
              className="email-capture__title-icon"
              type={ICON_TYPES.CHECK}
            />
            {successText || staticText.getIn(['data', 'thankYou'])}
          </H2>
        </div>
      )
    }

    return (
      <div className={gradient}>
        { withTitle
          ? <H6 className="email-capture__cta">
            {staticText.getIn(['data', 'title'])}
          </H6>
          : null
        }
        <div className={getClassName(className)}>
          {processing ? <div className="email-capture__processing"><Sherpa /></div> : null}
          <FormsyForm
            onValid={this.enableButton}
            onInvalid={this.disableButton}
            onValidSubmit={this.onEmailSignup}
          >
            <div className="email-capture__input-wrapper">
              <div className="email-capture__fields">
                <EmailInput
                  autocomplete="off"
                  validations="isEmail"
                  className="email-capture__input"
                  // validationError={staticText.getIn(['data', 'enterValidEmail'])}
                  // errorsVisibleDelay={800}
                  label={placeholder}
                  name={name}
                  value=""
                  inverted={inverted}
                  required
                />
              </div>
              <Button
                type={TYPES.PRIMARY}
                submit
                disabled={submitDisabled}
                className="email-capture__submit"
              >
                {text}
              </Button>
              {
                errorCode && errorMessage
                  ? <div className="email-capture__error">{`* ${errorMessage}`}</div>
                  : null
              }
              <div className="email-capture__subtext">{subtext}</div>
            </div>
          </FormsyForm>
        </div>
      </div>
    )
  }
}

EmailCapture.defaultProps = {
  inverted: true,
  name: 'emailSignup',
  uiLocation: 'Unknown',
}

EmailCapture.propTypes = {
  name: PropTypes.string,
  inverted: PropTypes.bool,
  className: PropTypes.array,
  subtext: PropTypes.string,
  successText: PropTypes.string,
  success: PropTypes.bool,
  formName: PropTypes.string,
  siteSegment: ImmutablePropTypes.map,
  onFormSubmit: PropTypes.func,
  buttonText: PropTypes.string,
  inputPlaceholder: PropTypes.string,
  staticText: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  emailSignup: ImmutablePropTypes.map.isRequired,
  url: PropTypes.string,
  utm: PropTypes.string,
  signupEvent: PropTypes.func,
  setEmailSignupOptin: PropTypes.func.isRequired,
  setEventLead: PropTypes.func,
  uiLocation: PropTypes.string,
}
// TODO: Refactor so onFormSubmit don't need to be passed in
export default connectRedux(
  (state) => ({
    staticText: state.staticText.getIn(['data', 'emailCapture']),
    user: state.user,
    uid: state.user.getIn(['data', 'uid']),
    emailSignup: state.emailSignup,
    url: state.page.get('path'),
    utm: state.inboundTracking.getIn(['data', 'strings', 'utm']),
    processing: state.emailSignup.get('processing'),
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      setEmailSignupOptin: actions.emailSignup.setEmailSignupOptin,
      setEventLead: actions.eventTracking.setEventLead,
      setDefaultGa4Event: actions.eventTracking.setDefaultGa4Event,
    }
  },
)(EmailCapture)
